module.exports = __webpack_public_path__ + "img/3.494cd94d.jpeg";